import { Component, OnInit } from '@angular/core';
import { AuthService, SharedService } from '@app/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.sharedService.resetSelectedEntityFormControl();
    this.sharedService.cancelAPICalls$.next();
    const token = this.authService.token;
    this.authService.logout(token);
  }

}
